import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/img/logo.png'
import _imports_1 from '@/assets/img/Tessere-SoloBarcode.png'
import _imports_2 from '@/assets/img/Tessere-SoloRfid.png'
import _imports_3 from '@/assets/img/PosizioneTesseraSanitaria_animazione3.png'
import _imports_4 from '@/assets/img/PosizioneTesseraSanitaria_animazione2.png'
import _imports_5 from '@/assets/img/PosizioneTesseraSanitaria_animazione1.png'
import _imports_6 from '@/assets/img/PosizioneTesseraRFID_animazione3.png'
import _imports_7 from '@/assets/img/PosizioneTesseraRFID_animazione2.png'
import _imports_8 from '@/assets/img/PosizioneTesseraRFID_animazione1.png'


const _hoisted_1 = {
  key: 0,
  width: "770",
  height: "500",
  loop: "",
  autoplay: ""
}
const _hoisted_2 = { class: "mySlides fade" }
const _hoisted_3 = { class: "t" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = {
  class: "tr",
  style: {"text-transform":"uppercase"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "mySlides fade" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_7 = { class: "mySlides fade" }
const _hoisted_8 = { style: {"vertical-align":"center","padding-top":"150px","font-size":"35pt","font-weight":"bold"} }
const _hoisted_9 = { class: "mySlides fade" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: _imports_1,
  alt: "tessera sanitaria"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "mySlides fade" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = ["innerHTML"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "img-crossfade" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-cont" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_3,
      alt: "qwe"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "img-cont" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: "qwe"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "img-cont" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: "qwe"
    })
  ])
], -1)
const _hoisted_20 = { class: "mySlides fade" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "img-crossfade" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "img-cont" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_6,
      alt: "qwe"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "img-cont" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_7,
      alt: "qwe"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "img-cont" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_8,
      alt: "qwe"
    })
  ])
], -1)
const _hoisted_26 = { style: {"position":"absolute","top":"0","left":"0","text-align":"center","width":"100%","z-index":"10"} }
const _hoisted_27 = { style: {"margin-top":"60px","padding":"0 16px","min-height":"60px","display":"flex","align-items":"center","justify-content":"center","font-size":"24pt"} }
const _hoisted_28 = {
  key: 1,
  style: {"padding":"20px 0","margin":"0 15px","background":"#4caf50","color":"#fff"}
}
const _hoisted_29 = { class: "wrapper" }
const _hoisted_30 = {
  key: 0,
  class: "content"
}
const _hoisted_31 = {
  class: "title",
  style: {"display":"flex"}
}
const _hoisted_32 = { style: {"flex":"1","padding-right":"20px"} }
const _hoisted_33 = {
  key: 0,
  style: {"width":"100%","padding":"20px","color":"#fff","background":"red","margin":"40px 0 20px","font-weight":"bold"}
}
const _hoisted_34 = { class: "book-title__chart-container" }
const _hoisted_35 = { class: "actions" }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = { class: "wrapper" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = { class: "title" }
const _hoisted_40 = {
  key: 0,
  style: {"width":"100%","padding":"20px","color":"#fff","background":"red","margin":"40px 0 20px","font-weight":"bold"}
}
const _hoisted_41 = { class: "actions" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "wrapper" }
const _hoisted_44 = { class: "content" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = {
  key: 0,
  style: {"width":"100%","padding":"20px","color":"#fff","background":"red","margin":"40px 0 20px","font-weight":"bold"}
}
const _hoisted_47 = { class: "actions" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = { class: "wrapper" }
const _hoisted_50 = { class: "content" }
const _hoisted_51 = {
  class: "title",
  style: {"display":"flex"}
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("span", { style: {"flex":"1","padding-right":"20px"} }, "Gestione materiali", -1)
const _hoisted_53 = ["onClick"]
const _hoisted_54 = {
  key: 0,
  class: "actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sb_spinner = _resolveComponent("sb-spinner")!
  const _component_sb_nav_bar = _resolveComponent("sb-nav-bar")!
  const _component_sb_carousel = _resolveComponent("sb-carousel")!
  const _component_sb_drawers = _resolveComponent("sb-drawers")!
  const _component_sb_footer = _resolveComponent("sb-footer")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_GDialog = _resolveComponent("GDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_sb_spinner, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style['container'])
    }, [
      _createVNode(_component_sb_nav_bar, { title: _ctx.title }, null, 8, ["title"]),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.$style['container__main-area'])
      }, [
        ((_ctx.template === 'arzignano') && !_ctx.adminMode)
          ? (_openBlock(), _createElementBlock("video", _hoisted_1, " video "))
          : (!_ctx.adminMode)
            ? (_openBlock(), _createBlock(_component_sb_carousel, { key: 1 }, _createSlots({
                slot0: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.anis1r1")) + " ", 1),
                      _hoisted_4,
                      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.libraryName), 1)
                    ])
                  ])
                ]),
                slot1: _withCtx(() => [
                  _hoisted_6
                ]),
                slot2: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("message.anis3r1")) + "! ", 1)
                  ])
                ]),
                _: 2
              }, [
                (!_ctx.isThereCardRFID)
                  ? {
                      name: "slot3",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t("message.onlytesserasan1")
                          }, null, 8, _hoisted_10),
                          _createElementVNode("div", {
                            class: "ts",
                            innerHTML: _ctx.$t("message.onlytesserasan2")
                          }, null, 8, _hoisted_11),
                          _hoisted_12,
                          _hoisted_13
                        ])
                      ]),
                      key: "0"
                    }
                  : {
                      name: "slot3",
                      fn: _withCtx(() => [
                        _createElementVNode("div", { class: "mySlides fade" }, [
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.tesserasanorrfid1')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("div", {
                            class: "ts",
                            innerHTML: _ctx.$t('message.tesserasanorrfid2')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("img", {
                            style: {"width":"100%"},
                            src: _imports_1,
                            alt: "tessera sanitaria"
                          }),
                          _createElementVNode("br"),
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.tesserasanorrfid3')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("img", {
                            style: {"width":"100%"},
                            src: _imports_2,
                            alt: "tessera rfid biblioteca"
                          }),
                          _createElementVNode("br")
                        ])
                      ]),
                      key: "1"
                    },
                (!_ctx.isThereCardRFID)
                  ? {
                      name: "slot4",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.ifonlytesserasan1')
                          }, null, 8, _hoisted_15),
                          _createElementVNode("div", {
                            class: "ts",
                            innerHTML: _ctx.$t('message.ifonlytesserasan2')
                          }, null, 8, _hoisted_16),
                          _hoisted_17,
                          _hoisted_18,
                          _hoisted_19
                        ])
                      ]),
                      key: "2"
                    }
                  : {
                      name: "slot4",
                      fn: _withCtx(() => [
                        _createElementVNode("div", { class: "mySlides fade" }, [
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.iftesserasan1')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("div", {
                            class: "ts",
                            innerHTML: _ctx.$t('message.iftesserasan2')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.iftesserasan3')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("div", {
                            class: "ts",
                            innerHTML: _ctx.$t('message.iftesserasan4')
                          }, null, 8, ["innerHTML"]),
                          _createElementVNode("br"),
                          _createElementVNode("br"),
                          _createElementVNode("div", { class: "img-crossfade" }, [
                            _createElementVNode("div", { class: "img-cont" }, [
                              _createElementVNode("img", {
                                src: _imports_3,
                                alt: "qwe"
                              })
                            ]),
                            _createElementVNode("div", { class: "img-cont" }, [
                              _createElementVNode("img", {
                                src: _imports_4,
                                alt: "qwe"
                              })
                            ]),
                            _createElementVNode("div", { class: "img-cont" }, [
                              _createElementVNode("img", {
                                src: _imports_5,
                                alt: "qwe"
                              })
                            ])
                          ])
                        ])
                      ]),
                      key: "3"
                    },
                (_ctx.isThereCardRFID)
                  ? {
                      name: "slot6",
                      fn: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.ifrfid1')
                          }, null, 8, _hoisted_21),
                          _createElementVNode("div", {
                            class: "t",
                            innerHTML: _ctx.$t('message.ifrfid2')
                          }, null, 8, _hoisted_22),
                          _hoisted_23,
                          _hoisted_24,
                          _hoisted_25
                        ])
                      ]),
                      key: "4"
                    }
                  : undefined
              ]), 1024))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.infoMessage), 1),
          (_ctx.infoMessage)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn--alert",
                style: {"width":"100px","flex":"initial"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancelLoading && _ctx.onCancelLoading(...args)))
              }, "Annulla"))
            : _createCommentVNode("", true),
          (_ctx.infoMessage)
            ? (_openBlock(), _createElementBlock("h2", _hoisted_28, _toDisplayString(_ctx.materialAlreadyPresent), 1))
            : _createCommentVNode("", true)
        ]),
        (_ctx.adminMode)
          ? (_openBlock(), _createBlock(_component_sb_drawers, {
              key: 2,
              prefs: _ctx.prefs,
              columns: _ctx.columns,
              actualItem: _ctx.actualItem,
              block: _ctx.actualItem && _ctx.actualItem.LoanStatus === 'B',
              onDrawerClick: _ctx.onDrawerClick,
              onServiceDrawerClick: _ctx.onServiceDrawerClick
            }, null, 8, ["prefs", "columns", "actualItem", "block", "onDrawerClick", "onServiceDrawerClick"]))
          : _createCommentVNode("", true)
      ], 2),
      _createVNode(_component_sb_footer, null, {
        default: _withCtx(() => [
          _createTextVNode(" Comperio srl - Biblio Smart Locker © v" + _toDisplayString(_ctx.release) + " " + _toDisplayString((new Date()).getFullYear()) + " - " + _toDisplayString(_ctx.$t("message.hello")) + " - " + _toDisplayString(_ctx.itemToCheckOut) + " - " + _toDisplayString(_ctx.itemCheckedOut) + " - " + _toDisplayString(_ctx.itemInError) + " - " + _toDisplayString(_ctx.timeoutVal), 1)
        ]),
        _: 1
      })
    ], 2),
    _createVNode(_component_GDialog, {
      modelValue: _ctx.patronOk,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.patronOk) = $event)),
      persistent: "",
      width: "100%",
      class: _normalizeClass(_ctx.$style['patron-ok'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          (_ctx.actualPatronCells.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.$t("message.itemsavailable")), 1),
                  (_ctx.actualPatronCells.length > 0)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn--outline-gray",
                        style: {"width":"60px","flex":"initial","min-width":"initial","margin":"-10px","background":"red","padding":"10px"},
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.userCancel && _ctx.userCancel(...args)))
                      }, [
                        _createVNode(_component_Icon, {
                          icon: "mdi:close",
                          style: {"color":"#fff","font-weight":"bold","font-size":"32px"}
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.libIsClosed === 0 && _ctx.isThereALock)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.$t("message.biblioopened")), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.$style['patron-ok__user'])
                }, _toDisplayString(_ctx.$t("message.user")) + ": " + _toDisplayString(_ctx.actualPatron.Name) + " - " + _toDisplayString(_ctx.actualPatron.Barcode), 3),
                _createElementVNode("ul", {
                  class: _normalizeClass(_ctx.$style['patron-ok__title-list'])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actualPatronCells, (item) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(_ctx.$style['title-list__title-item']),
                      key: item.barcode
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "mdi:check-circle",
                        class: _normalizeClass(_ctx.$style['title-item__left-icon'])
                      }, null, 8, ["class"]),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.$style['title-item__book-title'])
                      }, _toDisplayString(item.title), 3),
                      _createElementVNode("div", _hoisted_34, [
                        (item.status==='ok' || item.status==='error')
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(_ctx.$style['chart-container__right-action-cont-badge'])
                            }, [
                              _createElementVNode("div", {
                                class: _normalizeClass(_ctx.$style['right-action-cont-badge__inner-wrapper'])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.$style['inner-wrapper__background'])
                                }, null, 2),
                                (item.status==='error')
                                  ? (_openBlock(), _createBlock(_component_Icon, {
                                      key: 0,
                                      class: _normalizeClass([_ctx.$style['inner-wrapper__icon'], _ctx.$style['inner-wrapper__icon--red']]),
                                      icon: "mdi:warning-circle"
                                    }, null, 8, ["class"]))
                                  : _createCommentVNode("", true),
                                (item.status==='ok')
                                  ? (_openBlock(), _createBlock(_component_Icon, {
                                      key: 1,
                                      class: _normalizeClass([_ctx.$style['inner-wrapper__icon'], _ctx.$style['inner-wrapper__icon--green']]),
                                      icon: "mdi:check-circle"
                                    }, null, 8, ["class"]))
                                  : _createCommentVNode("", true)
                              ], 2)
                            ], 2))
                          : _createCommentVNode("", true),
                        (item.status==='ok' || item.status==='error' || item.status==='pending' || item.status==='ready')
                          ? (_openBlock(), _createBlock(_component_Icon, {
                              key: 1,
                              icon: "mdi:shopping-cart",
                              class: _normalizeClass(_ctx.$style['chart-container__right-icon'])
                            }, null, 8, ["class"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 2))
                  }), 128))
                ], 2)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("button", {
              class: "btn btn--confirm",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.userPick && _ctx.userPick(...args)))
            }, _toDisplayString(_ctx.$t("message.pick")), 1),
            (_ctx.libIsClosed >= 1 && _ctx.isThereALock)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn--confirm",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.openReturnLock && _ctx.openReturnLock(...args))),
                  disabled: _ctx.isOpenReturnDisabled
                }, _toDisplayString((_ctx.returnLockTimerValue >= 0) ? `Chiusura in ${_ctx.returnLockTimerValue}s` : _ctx.$t("message.opennreturncounter")), 9, _hoisted_36))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    _createVNode(_component_GDialog, {
      modelValue: _ctx.dialogOk,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.dialogOk) = $event)),
      persistent: "",
      width: "100%",
      class: _normalizeClass(_ctx.$style['dialog-ok'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t("message.okoperation")), 1),
            (_ctx.libIsClosed === 0 && _ctx.isThereALock)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t("message.biblioopened")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style['dialog-ok__user'])
            }, _toDisplayString(_ctx.$t("message.checkoutmessage",{ docs: _ctx.itemCheckedOut })), 3),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style['dialog-ok__user'])
            }, _toDisplayString(_ctx.$t("message.thankyou")), 3)
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("button", {
              class: "btn btn--confirm",
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.initUi && _ctx.initUi(...args)))
            }, "OK"),
            (_ctx.print_template)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn--confirm",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.print && _ctx.print(...args)))
                }, _toDisplayString(_ctx.$t('message.stamparicevuta')), 1))
              : _createCommentVNode("", true),
            (_ctx.libIsClosed >= 1 && _ctx.isThereALock)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn--confirm",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openReturnLock && _ctx.openReturnLock(...args))),
                  disabled: _ctx.isOpenReturnDisabled
                }, _toDisplayString((_ctx.returnLockTimerValue >= 0) ? `Chiusura in ${_ctx.returnLockTimerValue}s` : _ctx.$t("message.opennreturncounter")), 9, _hoisted_42))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    _createVNode(_component_GDialog, {
      modelValue: _ctx.dialogKo,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.dialogKo) = $event)),
      persistent: "",
      width: "100%",
      class: _normalizeClass(_ctx.$style['dialog-ko'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.patronErrorTitle), 1),
            ((_ctx.libIsClosed === 0 && _ctx.isThereALock) && _ctx.actualPatron)
              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(_ctx.$t("message.biblioopened")), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style['dialog-ko__user'])
            }, _toDisplayString(_ctx.patronErrorMessage), 3)
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("button", {
              class: "btn btn--alert",
              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.dismiss && _ctx.dismiss(...args)))
            }, "OK"),
            ((_ctx.libIsClosed >= 1) && _ctx.actualPatron && _ctx.isThereALock)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn--confirm",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openReturnLock && _ctx.openReturnLock(...args))),
                  disabled: _ctx.isOpenReturnDisabled
                }, _toDisplayString((_ctx.returnLockTimerValue >= 0) ? `Chiusura in ${_ctx.returnLockTimerValue}s` : _ctx.$t("message.opennreturncounter")), 9, _hoisted_48))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"]),
    _createVNode(_component_GDialog, {
      modelValue: _ctx.adminDialog,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.adminDialog) = $event)),
      persistent: "",
      width: "100%",
      class: _normalizeClass(_ctx.$style['admin-dialog'])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_49, [
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _createElementVNode("button", {
                class: "btn btn--outline-gray",
                style: {"width":"60px","flex":"initial","min-width":"initial","margin":"-10px","background":"red","padding":"10px"},
                onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.adminCellClose && _ctx.adminCellClose(...args)))
              }, [
                _createVNode(_component_Icon, {
                  icon: "mdi:close",
                  style: {"color":"#fff","font-weight":"bold","font-size":"32px"}
                })
              ])
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(_ctx.$style['admin-dialog__user'])
            }, " Utente: " + _toDisplayString(_ctx.lockerDB[_ctx.selectedDbCellId] && _ctx.lockerDB[_ctx.selectedDbCellId].patronbarcode) + " - Giorni di giacenza: " + _toDisplayString(_ctx.lockerDB[_ctx.selectedDbCellId] && _ctx.lockerDB[_ctx.selectedDbCellId].days), 3),
            (_ctx.lockerDB[_ctx.selectedDbCellId])
              ? (_openBlock(), _createElementBlock("ul", {
                  key: 0,
                  class: _normalizeClass(_ctx.$style['admin-dialog__title-list'])
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lockerDB[_ctx.selectedDbCellId].items, (item, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass(_ctx.$style['title-list__title-item']),
                      key: item.barcode
                    }, [
                      _createVNode(_component_Icon, {
                        icon: "mdi:check-circle",
                        class: _normalizeClass(_ctx.$style['title-item__left-icon'])
                      }, null, 8, ["class"]),
                      _createElementVNode("span", {
                        class: _normalizeClass(_ctx.$style['title-item__book-title'])
                      }, _toDisplayString(item.title), 3),
                      _createElementVNode("button", {
                        class: "btn btn--alert",
                        style: {"flex":"none"},
                        onClick: ($event: any) => (_ctx.onUnloadItem(_ctx.lockerDB[_ctx.selectedDbCellId], index))
                      }, [
                        _createVNode(_component_Icon, {
                          icon: "mdi:close-circle",
                          class: _normalizeClass([_ctx.$style['title-item__right-icon']])
                        }, null, 8, ["class"]),
                        _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                      ], 8, _hoisted_53)
                    ], 2))
                  }), 128))
                ], 2))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.insertItem)
            ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                _createElementVNode("button", {
                  class: "btn btn--confirm",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.adminCellOpen && _ctx.adminCellOpen(...args)))
                }, "Apri"),
                _createElementVNode("button", {
                  class: "btn btn--alert",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.adminCellUnload && _ctx.adminCellUnload(...args)))
                }, _toDisplayString(_ctx.$t("message.emptydrawer")), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "class"])
  ], 64))
}